import { gsap } from 'gsap';

export function gsapCounter() {
  return {
    name: 'counter',
    extendTimeline: true,
    defaults: {
      end: 0,
      start: 0,
      duration: 0.5,
      ease: 'power1',
      increment: 1,
    },
    effect: (targets, config) => {
      const tl = gsap.timeline();
      targets[0].innerText = config.start;

      tl.to(
        targets,
        {
          duration: config.duration,
          innerText: config.end,
          //snap:{innerText:config.increment},
          modifiers: {
            innerText: function (innerText) {
              return gsap.utils.snap(config.increment, innerText).toString();
            },
          },
          ease: config.ease,
        },
        0,
      );

      return tl;
    },
  };
}
